import React from 'react';
import { Phone, MessageSquare, Send, Download } from 'lucide-react';

export default function FloatingCTA({ onOpenBrochure, onApplyClick }) {
  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 999,
      backgroundColor: 'rgba(15, 37, 55, 0.96)',
      backdropFilter: 'blur(10px)',
      borderTop: '1px solid rgba(212, 175, 55, 0.4)',
      padding: '0.5rem 0.75rem',
      boxShadow: '0 -10px 25px rgba(0, 0, 0, 0.3)',
      boxSizing: 'border-box',
      width: '100%'
    }}>
      <div className="container" style={{
        display: 'flex',
        justify: 'space-between',
        alignItems: 'center',
        gap: '0.75rem',
        width: '100%'
      }}>
        
        {/* Contact Info Text */}
        <div className="cta-hide-mobile" style={{ display: 'flex', alignItems: 'center', gap: '0.85rem' }}>
          <a
            href="tel:+917631900600"
            style={{
              color: '#FFFFFF',
              textDecoration: 'none',
              fontSize: '0.88rem',
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center',
              gap: '0.4rem'
            }}
          >
            <Phone size={15} color="#D4AF37" /> Helpline: +91 7631 900 600
          </a>
          <span style={{ color: 'rgba(255, 255, 255, 0.2)' }}>|</span>
          <span style={{ color: '#FEF08A', fontSize: '0.82rem', fontWeight: 600 }}>
            ⚡ Admissions Open for July 2026 Batch
          </span>
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', width: '100%', justifyContent: 'flex-end' }} className="cta-btn-group">
          <a
            href="https://api.whatsapp.com/send?phone=917631900600&text=Hi,%20I%20want%20information%20about%20Christ%20University%20Online%20Programmes"
            target="_blank"
            rel="noreferrer"
            className="cta-btn-whatsapp"
            style={{
              backgroundColor: '#25D366',
              color: '#FFFFFF',
              borderRadius: '8px',
              padding: '0.55rem 0.85rem',
              fontSize: '0.82rem',
              fontWeight: 700,
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.3rem',
              flexShrink: 0,
              whiteSpace: 'nowrap'
            }}
          >
            <MessageSquare size={15} /> WhatsApp
          </a>

          <button
            onClick={onOpenBrochure}
            className="btn-secondary cta-btn-prospectus"
            style={{ padding: '0.55rem 0.85rem', fontSize: '0.82rem', flexShrink: 0, whiteSpace: 'nowrap' }}
          >
            <Download size={14} color="#D4AF37" /> Prospectus
          </button>

          <button
            onClick={onApplyClick}
            className="btn-primary cta-btn-apply"
            style={{ padding: '0.55rem 1rem', fontSize: '0.85rem', flexShrink: 0, whiteSpace: 'nowrap' }}
          >
            Apply Now <Send size={14} />
          </button>
        </div>

      </div>

      <style>{`
        @media (max-width: 640px) {
          .cta-hide-mobile { display: none !important; }
          .cta-btn-group {
            justify-content: space-between !important;
            gap: 0.35rem !important;
            width: 100% !important;
          }
          .cta-btn-whatsapp, .cta-btn-prospectus, .cta-btn-apply {
            padding: 0.45rem 0.35rem !important;
            font-size: 0.74rem !important;
            flex: 1 !important;
            min-width: 0 !important;
            justify-content: center !important;
            border-radius: 6px !important;
          }
        }
      `}</style>
    </div>
  );
}
